import { ArrowRight, Phone } from 'lucide-react'
import { Button } from './button'

export const Header = () => {
	return (
		<header className="flex items-center justify-between px-14 py-3.5">
			<div className="flex items-center gap-10 md:gap-16 lg:gap-32">
				<img
					src="https://nuserenitywellness.com/wp-content/uploads/2022/03/ab-seal-blue-hero-657x414-removebg-preview-183x300.png"
					width={83}
					height={300}
					alt="BBB Accredited Business logo."
					className="h-auto w-14"
				/>
				<a href="tel:4804623882">
					<Button className="group flex items-center gap-2">
						Call Us{' '}
						<Phone className="group-hover:fill-primary size-4 scale-x-105 rotate-270 fill-white" />
					</Button>
				</a>
			</div>
			<img
				src="https://nuserenitywellness.com/wp-content/uploads/2022/03/FullLogo_Transparent_NoBuffer.png"
				alt="Here's an alt tag for the image: Nuserenity logo: yoga pose design."
				width={1280}
				height={762}
				className="h-auto w-[211px]"
			/>
			<div className="flex items-center gap-10">
				<a
					href="https://nuserenitywellness.com/new-patient-steps/"
					target="_blank">
					<Button className="flex items-center gap-2">
						Book Now <ArrowRight className="size-4 scale-x-150" />
					</Button>
				</a>
				<a href="https://nuserenitywellness.com/wp-login.php">
					<Button>Provider Login</Button>
				</a>
			</div>
		</header>
	)
}
